
function User() {
    this.nombre = null;
    this.username = null;
    this.token = null;
    this.isSuccess = false;
    this.menu = [];
};

export default User;